import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from './actions';
import { ClassDigitalNotebookStudentsStatus } from './type';

type ClassDigitalNotesFeatureActions = ActionType<typeof actions>;

const initialState: ClassDigitalNotebookStudentsStatus = {};

const reducer = createReducer<
  ClassDigitalNotebookStudentsStatus,
  ClassDigitalNotesFeatureActions
>(initialState).handleAction(
  actions.setStudentsStatus,
  (state, { payload }) => {
    if (
      !payload.studentId ||
      typeof payload.studentId !== 'string' ||
      !payload.componentId ||
      typeof payload.componentId !== 'string'
    )
      return state;
    return {
      ...state,
      [payload.studentId]: {
        ...(state[payload.studentId] || {}),
        [payload.componentId]: payload.status,
      },
    };
  }
);

export default reducer;
